<template>
    <div class="app-container">
        <el-form
            ref="addAddressform"
            label-width="100px"
            :inline="true"
            :model="addAddressform"
            :rules="addAddressRules"
        >
            <el-form-item label="安装地区" prop="label">
                <el-cascader
                    ref="district"
                    v-model="addAddressform.label"
                    :options="options_"
                    placeholder="省市区"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input
                    v-model="addAddressform.address"
                    maxlength="50"
                    style="width: 240px"
                />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
export default {
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            options_: regionData,
            addAddressform: {
                id:'',
                main:'',
                label: [],
                district:[],
                address: "",
            },
            addAddressRules: {
                label: [
                    {
                        required: true,
                        message: "请选择安装地区",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入详细地址",
                    },
                ],
            },
        };
    },
    methods: {
        getInfo() {
            this.addAddressform.id = this.item.id;
            this.addAddressform.main = this.item.main;
            this.addAddressform.district = this.item.district;
            this.addAddressform.address = this.item.address;
            this.addAddressform.label = [];
            if (this.item.district.length > 0) {
                this.addAddressform.label.push(
                    TextToCode[this.item.district[0]].code
                );
            }
            if (this.item.district.length > 1) {
                this.addAddressform.label.push(
                    TextToCode[this.item.district[0]][this.item.district[1]].code
                );
            }
            if (this.item.district.length > 2) {
                this.addAddressform.label.push(
                    TextToCode[this.item.district[0]][this.item.district[1]][this.item.district[2]].code
                );
            }
        },
        saveEditClose() {
            this.$refs.addAddressform.validate((valid) => {
                if (valid) {
                    this.addAddressform.district = [];
                    this.addAddressform.district.push(
                        CodeToText[this.addAddressform.label[0]]
                    );
                    this.addAddressform.district.push(
                        CodeToText[this.addAddressform.label[1]]
                    );
                    this.addAddressform.district.push(
                        CodeToText[this.addAddressform.label[2]]
                    )
                    let obj = {
                        id:this.addAddressform.id,
                        main:this.addAddressform.main,
                        district:this.addAddressform.district.join(','),
                        address: this.addAddressform.address,
                    }
                    this.$api
                        .editCustomerWorkAddress(obj)
                        .then((res) => {
                            this.$emit("close");
                            this.$notify({
                                title: "修改安装地址",
                                message: "修改成功",
                                type: "success",
                                duration: 2000,
                            });
                        });
                } else {
                    this.$notify({
                        title: "信息填写不完善",
                        message: "请完善信息",
                        type: "warning",
                        duration: 2000,
                    });
                }
            });
        },
    },
};
</script>